import { useSprintQuery } from "sprint-common-web";

import { GetCloudAssetPreviewResponse } from "../../../../../../common/api/master-api/assets/get-preview/GetCloudAssetPreviewResponse";
import { useAssetsApi } from "../../../../../../common/api/master-api/assets/useAssetsApi";
import { useCloudFileApi } from "../../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudAssetStatus } from "../../../CloudAssetStatus";
import { CloudAssetQueryKey } from "../../../common/CloudAssetQueryKey";

export const useCloudAssetPreview = ({
    contentVersionIds,
    status,
    cloudFileId,
    assetId
}: {
    contentVersionIds?: string[];
    status?: CloudAssetStatus;
    cloudFileId?: string;
    assetId?: string;
}) => {
    const { getCloudAssetPreview } = useAssetsApi();
    const { getCloudFilePreview } = useCloudFileApi();

    return useSprintQuery<GetCloudAssetPreviewResponse | undefined>({
        queryKey: [CloudAssetQueryKey.CloudAssetPreview, contentVersionIds, cloudFileId, assetId],
        queryFn: async (): Promise<GetCloudAssetPreviewResponse | undefined> => {
            if (!contentVersionIds) {
                return undefined;
            }

            if (!cloudFileId) {
                return undefined;
            }

            if (!assetId) {
                return undefined;
            }

            return status === CloudAssetStatus.Active
                ? await getCloudAssetPreview({ contentVersionIds, assetId })
                : await getCloudFilePreview({ cloudFileId });
        },
        options: {
            useErrorBoundary: true,
            retry: false
        }
    });
};
